import { FlexRowAlignCenter } from "@/components/Flex";
import { themeColors } from "@/utils/themeColors";

export const GapPerSection = ({ height = "2rem" }) => {
    return <div style={{ paddingBottom: height }} />;
};

export const OrDivider = () => {
    return (
        <FlexRowAlignCenter style={{ gap: "2.2rem", width: "100%", maxWidth: "40rem", margin: "0 auto" }}>
            <div style={{ flex: 1, border: `1px solid ${themeColors.background}` }} />
            <span style={{ fontSize: "1.4rem", fontWeight: "600" }}>or</span>
            <div style={{ flex: 1, border: `1px solid ${themeColors.background}` }} />
        </FlexRowAlignCenter>
    );
};
